import { ausserhalb, type Form, type UiDaten } from "@gui-creator/gemeinsam";
import { useState } from "react";
import { Bestaetigung } from "../ui/Dialog.tsx";

const FORMEN: { wert: string; text: string; form: Form }[] = [
  ...([1, 2, 3, 4, 5, 6] as const).map((r) => ({ wert: `truhe-${r}`, text: r === 6 ? "6 Reihen · Doppeltruhe" : r === 1 ? "1 Reihe" : `${r} Reihen`, form: { art: "truhe", reihen: r } as Form })),
  { wert: "trichter", text: "Trichter · 5", form: { art: "trichter" } },
  { wert: "spender", text: "Spender · 3×3", form: { art: "spender" } },
];

const wertVon = (f: Form) => (f.art === "truhe" ? `truhe-${f.reihen}` : f.art);

export function Formwahl({ ui, deaktiviert, onWaehlen }: { ui: UiDaten; deaktiviert?: boolean; onWaehlen: (f: Form) => void }) {
  const [frage, setFrage] = useState<{ form: Form; verloren: number[] } | null>(null);
  const waehlen = (wert: string) => {
    const neu = FORMEN.find((f) => f.wert === wert)!.form;
    const verloren = ausserhalb(ui, neu);
    if (verloren.length) setFrage({ form: neu, verloren });
    else onWaehlen(neu);
  };
  return (
    <>
      <label className="werkzeug-feld">
        <span className="unsichtbar">Form</span>
        <select className="eingabe" value={wertVon(ui.form)} disabled={deaktiviert} onChange={(e) => waehlen(e.target.value)}>
          {FORMEN.map((f) => (
            <option key={f.wert} value={f.wert}>
              {f.text}
            </option>
          ))}
        </select>
      </label>
      <Bestaetigung
        offen={!!frage}
        titel="Form verkleinern?"
        bestaetigen="Entfernen und ändern"
        gefahr
        onAbbrechen={() => setFrage(null)}
        onBestaetigen={() => {
          if (frage) onWaehlen(frage.form);
          setFrage(null);
        }}
      >
        <p>In der neuen Form fehlen {frage?.verloren.length === 1 ? "dieser Slot" : "diese Slots"}: <span className="mono">{frage?.verloren.join(", ")}</span>.</p>
        <p>Was dort liegt, wird entfernt. Mit Strg+Z lässt es sich zurückholen.</p>
      </Bestaetigung>
    </>
  );
}
